import { mapActions, mapMutations } from 'vuex';
import OrignalFileViewer from '@/components/OrignalFileViewer';

const orignalFileViewerMixin = {
	components: {
		OrignalFileViewer,
	},
	mounted() {
		if(this.selectedFile && "originalFileUUID" in this.selectedFile) {
			this.tabItems.unshift({
				name: 'Orignal File',
				tabId: 'tab-00',
				component: 'OrignalFileViewer',
				props: {
					fileToView: this.selectedFile || {},
				},
			});
		}
		this.model = 'tab-00';
	},
};

export default orignalFileViewerMixin;
